<!-- src/components/layouts/UserInfo.vue -->
<template>
    <div v-if="user" class="user-info-container">
        <div class="avatar-section">
            <a-avatar :size="80" :image-url="userAvatarUrl" class="user-avatar" />
            <div class="user-primary-info">
                <h2 class="username">{{ user.username }}</h2>
                <p class="email">{{ user.email }}</p>
            </div>
        </div>
        
        <div class="info-details">
            <a-descriptions :column="1" bordered size="large" class="glass-descriptions">
                <a-descriptions-item label="用户角色">
                    <a-tag color="blue">管理员</a-tag>
                </a-descriptions-item>
                <a-descriptions-item label="所在地">{{ user.address || '未设置' }}</a-descriptions-item>
                <a-descriptions-item label="注册时间">
                    {{ formattedCreateTime }}
                </a-descriptions-item>
            </a-descriptions>
        </div>

        <div class="actions">
            <a-button type="primary" status="danger" long @click="handleLogout">
                <template #icon><icon-export /></template>
                退出登录
            </a-button>
        </div>
    </div>
    <div v-else>
        <a-skeleton :animation="true">
            <a-skeleton-line :rows="4" />
        </a-skeleton>
    </div>
</template>

<script>
import { defineComponent, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { Message } from '@arco-design/web-vue';
import { IconExport } from '@arco-design/web-vue/es/icon';
import dayjs from 'dayjs';

export default defineComponent({
    name: "UserInfo",
    components: { IconExport },
    setup() {
        const store = useStore();
        const router = useRouter();

        const user = computed(() => store.getters['user/currentUser']);

        const userAvatarUrl = computed(() => {
            if (user.value && user.value.avatar) {
                return `${process.env.VUE_APP_BASE_URL || ''}${user.value.avatar}`;
            }
            return 'https://picsum.photos/80';
        });

        const formattedCreateTime = computed(() => {
            if (user.value && user.value.createTime) {
                return dayjs(user.value.createTime).format('YYYY年MM月DD日 HH:mm');
            }
            return '未知';
        });

        const fetchUser = () => store.dispatch('user/fetchUser');

        const handleLogout = async () => {
            try {
                // 清除 Token
                window.localStorage.removeItem('adminToken');
                // 清除 Vuex 状态
                store.commit('user/setUser', null);
                
                Message.success('已成功退出登录');
                
                // 强制跳转
                await router.replace({ name: 'login' });
                
            } catch (err) {
                console.error('退出登录失败:', err);
                Message.error('退出登录失败，请重试');
            }
        };

        onMounted(async () => {
            try {
                await fetchUser();
            } catch (error) {
                console.error('加载用户信息失败:', error);
            }
        });

        return {
            user,
            userAvatarUrl,
            formattedCreateTime,
            handleLogout,
        };
    }
});
</script>

<style scoped>
.user-info-container {
    max-width: 600px;
    margin: 0 auto;
}

.avatar-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 30px;
}

.user-avatar {
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
    border: 2px solid white;
}

.user-primary-info {
    text-align: center;
    margin-top: 15px;
}

.username {
    font-size: 24px;
    font-weight: 600;
    color: var(--text-main);
    margin-bottom: 4px;
}

.email {
    color: var(--text-secondary);
    font-size: 14px;
}

.info-details {
    margin-bottom: 30px;
}

.glass-descriptions :deep(.arco-descriptions-item-label),
.glass-descriptions :deep(.arco-descriptions-item-value) {
    background: transparent;
}

.actions {
    margin-top: 20px;
}
</style>
